export const popularAppsForSearchSuggestionsKey =
  "popularAppsForSearchSuggestionsKey";
